// @flow
import type { Mutation } from "common/graphql/types"
import gql from "graphql-tag"

export const affiliateOnboardSendVerificationCode: Mutation<
  {
    input: {
      placeId: string,
      affiliateEmail: string,
      method: "call" | "sms",
    },
  },
  boolean
> = {
  gql: gql`
    mutation affiliateOnboardSendVerificationCode($input: AffiliateOnboardingSendVerificationCode!) {
      affiliate {
        onboardSendVerificationCode(input: $input)
      }
    }
  `,
  selector: ["affiliate", "onboardSendVerificationCode"],
}

export const affiliateOnboard: Mutation<{}, *> = {
  gql: gql`
    mutation affiliateOnboard($input: AffiliateOnboardingInput!) {
      affiliate {
        onboard(input: $input) {
          id
        }
      }
    }
  `,
  selector: ["affiliate", "onboard"],
}



// WEBPACK FOOTER //
// ./src/data/affiliate/mutations.js